import Learning from "./Learning";

export default Learning